import React from 'react'
import "./Cart.css"
import { useCart, useCartDispatch } from "../Contexts/CartProvider"

const Cart = () => {
    let data = useCart();
    let dispatch = useCartDispatch();
    if (data.length === 0) {
        return (
            <div className="empty-card">
                Cart is empty
            </div>
        )
    }

    const handleRemove = async (index) => {
        await dispatch({
            type: "REMOVE",
            index: index
        })
    }

    const handleCheckOut = async () => {
        let userEmail = localStorage.getItem("userEmail");
        let response = await fetch("https://hungryhub-backend.vercel.app/api/orderdata", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                orderData: data,
                email: userEmail,
                orderDate: new Date().toDateString()
            })
        })
        if (response.status === 200) {
            dispatch({ type: "DROP" });
        }
    }
    let totalPrice = data.reduce((total, food) => total + food.price, 0);
    return (
        <main className='my-cart'>
            <div className="cart">
                <ul>
                    {
                        data.map((food, index) => {
                            return (
                                <li className="cart-item" key={index}>
                                    <img src={food.img} alt='food-img' />
                                    <div className="item-details">
                                        <h3>{food.name}</h3>
                                        <p>Price: ₹{food.price}</p>
                                        <p>Quantity: {food.quantity}</p>
                                        <p>Option: {food.size}</p>
                                    </div>
                                    <button className="remove-button" onClick={() => handleRemove(index)}>Remove</button>
                                </li>
                            )
                        })
                    }
                </ul>
                <div className="cart-total">
                    <h3>Total: ₹{totalPrice}</h3>
                    <button className="checkout-button" onClick={handleCheckOut}>Checkout</button>
                </div>
            </div>
        </main>
    )
}

export default Cart
